import { Button, FormControl, FormHelperText, FormLabel, Input, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';

interface SignUpFormProps {
  onSubmit: (username: string, password: string) => void;
  disabledSubmit?: boolean;
}

interface SignUpFormValues {
  username: string;
  password: string;
  password_repeat: string;
}

export function SignUpForm(props: SignUpFormProps) {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<SignUpFormValues>();

  const onSubmit = (data: SignUpFormValues) => {
    props.onSubmit(data.username, data.password);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2} sx={{ mb: 2 }}>
        <FormControl required fullWidth error={!!errors.username}>
          <FormLabel>E-mail</FormLabel>
          <Input autoComplete="username" {...register('username', { required: 'E-mail je povinný' })} />
          {errors.username && <FormHelperText>{errors.username.message}</FormHelperText>}
        </FormControl>

        <FormControl required error={!!errors.password}>
          <FormLabel>Heslo</FormLabel>
          <Input
            type="password"
            autoComplete="new-password"
            {...register('password', {
              required: 'Heslo je povinné',
              minLength: { value: 8, message: 'Heslo musí mať aspoň 8 znakov' },
            })}
          />
          {errors.password && <FormHelperText>{errors.password.message}</FormHelperText>}
        </FormControl>

        <FormControl required error={!!errors.password_repeat}>
          <FormLabel>Zopakuj heslo</FormLabel>
          <Input
            type="password"
            autoComplete="new-password"
            {...register('password_repeat', {
              required: 'Potvrdenie hesla je povinné',
              validate: (value) => value === getValues('password') || 'Heslá sa nezhodujú',
            })}
          />
          {errors.password_repeat && <FormHelperText>{errors.password_repeat.message}</FormHelperText>}
        </FormControl>
      </Stack>

      <Button type="submit" fullWidth variant="contained" disabled={props.disabledSubmit}>
        Registrujte sa
      </Button>
    </form>
  );
}
